import { LogoutApi } from "@/features/auth/services/logout-api";
import { LogoutPostRequestModel } from "@/features/auth/services/logout-model";


export class LogoutService {
  private logoutApi = new LogoutApi();

  public async postLogout(param: LogoutPostRequestModel) {
    return await this.logoutApi.postLogout(param);
  }
}
